import { createContext, FC, useState, useContext } from 'react';
import type { ThemeConfig } from '@/utils/theme';

// Always the *canonical* theme config: every producer normalizes its wire shape
// (nested `ServerInvoiceRes['theme']` or flat `PaymentPageThemeDto`) before
// storing, so consumers never see an unresolved mode/colorConfig (PAA-3012).
type ThemeData = ThemeConfig | null;

type ThemeDataStore = {
  themeData: ThemeData;
  setThemeData: (data: ThemeData) => void;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const ThemeDataContext = createContext<ThemeDataStore>({
  themeData: null,
  setThemeData: noop,
});

export const ThemeDataProvider: FC = ({ children }) => {
  const [themeData, setThemeData] = useState<ThemeData>(null);
  return <ThemeDataContext.Provider value={{ themeData, setThemeData }}>{children}</ThemeDataContext.Provider>;
};

export const useThemeData = (): ThemeDataStore => useContext(ThemeDataContext);
